import { api } from "./axios";

export type OpenChestResponse = {
  success: boolean;
  point: number;
};

export type ChestStatusResponse = {
  claimed: boolean;
  opened: boolean;
};

export const postOpenChest = async (
  fid: number
): Promise<OpenChestResponse> => {
  const { data } = await api.post("/chest/open", { fid });
  return data;
};

export const getChestStatus = async (
  fid: number
): Promise<ChestStatusResponse> => {
  const { data } = await api.get(`/chest/status/${fid}`);
  return data;
};
